import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ActivityFeedPage = lazy(async () => {
  const m = await import("@/features/activity/components/activity-feed-page");
  return { default: m.ActivityFeedPage };
});

/**
 * ACTIVITY-CORE (L3) — feed "quién hizo qué" de la cuenta y sus organizaciones.
 * Variante stockpilot: ajustes de existencias SIEMPRE con actor + motivo y
 * correcciones como contramovimientos explícitos (requisito ERP).
 */
export const activityRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/activity",
  component: () => (
    <Suspense fallback={null}>
      <ActivityFeedPage />
    </Suspense>
  ),
});
